export const isScadaRuntimeRoute = (pathname = "") =>
  pathname.includes("scada-runtime") || /\/scada-projects\/[^/]+\/screens\/[^/]+\/runtime\/?$/.test(pathname);

export const isScadaSimulationRoute = (pathname = "") =>
  /\/scada-projects\/[^/]+\/screens\/[^/]+\/simulation\/?$/.test(pathname);

export const isEmbeddedScadaRuntime = ({ pathname = "", search = "" } = {}) =>
  (isScadaRuntimeRoute(pathname) || isScadaSimulationRoute(pathname)) &&
  new URLSearchParams(search).get("embed") === "1";

export const isPopupEmbeddedScadaRuntime = ({ pathname = "", search = "" } = {}) =>
  isEmbeddedScadaRuntime({ pathname, search }) && new URLSearchParams(search).get("popup") === "1";

export const canShowRuntimeDataViewer = ({
  runtimeRoute = false,
  simulationRoute = false,
  simulationEnabled = false,
  popupRuntime = false,
  subScreenRuntime = false,
} = {}) =>
  (runtimeRoute || simulationRoute || simulationEnabled) && !popupRuntime && !subScreenRuntime;

export const withScadaRuntimeEmbed = (route, { popup = false } = {}) => {
  const value = String(route || "").trim();
  if (!value) return "";

  const hashIndex = value.indexOf("#");
  const hash = hashIndex >= 0 ? value.slice(hashIndex) : "";
  const routeWithoutHash = hashIndex >= 0 ? value.slice(0, hashIndex) : value;
  const queryIndex = routeWithoutHash.indexOf("?");
  const pathname = queryIndex >= 0 ? routeWithoutHash.slice(0, queryIndex) : routeWithoutHash;
  const search = queryIndex >= 0 ? routeWithoutHash.slice(queryIndex + 1) : "";
  const searchParams = new URLSearchParams(search);

  searchParams.set("embed", "1");
  if (popup) searchParams.set("popup", "1");
  return `${pathname}?${searchParams.toString()}${hash}`;
};
